<mat-card>
  <mat-card-title><span class="accent">Logged In</span></mat-card-title>
  <mat-card-content>
    <span class="accent">You may close this window.</span>
  </mat-card-content>
</mat-card>
